import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { App } from './App';
import { ApiError } from './lib/api';
import { SESSION_KEY } from './lib/session';
import { ToastProvider } from './lib/toast';
import './index.css';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // A session that expires mid-visit shows up as a 401 on whatever query
    // fires next; clearing the cached session drops the app back to login
    // rather than leaving a screen of failed panels.
    onError: (error) => {
      if (error instanceof ApiError && error.isUnauthorized) {
        queryClient.setQueryData(SESSION_KEY, null);
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        // Retrying a rejected request only delays the error the operator needs
        // to see; transient network failures are still worth one more go.
        !(error instanceof ApiError && error.status < 500) && failureCount < 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
